module.exports = __webpack_public_path__ + "img/search-small.18722025.svg";